import { Paragraph } from "../../../../lib/Font/styles";
import { CheckIconRounded, Container, Heading, SmallerHeading, TextMessageContainer, TopicContainer, TopicTextContainer, SecondaryText } from "./styles";
import { COLORS } from "../../../../values/colors";
import CheckIcon from '@mui/icons-material/Check';
import SubmitButton from "../../../base/Buttons/SubmitButton/SubmitButton";
import { useNavigate } from 'react-router-dom';

const MessageConfirmed = () => {
    const navigate = useNavigate();
    return (
        <Container>
            <TopicContainer>
                <CheckIconRounded>
                    <CheckIcon 
                        style={{ 
                            color: COLORS.darkGray, 
                            fontSize: window.innerWidth < 620 ? '2rem' : '3.5rem' 
                        }} 
                    />
                </CheckIconRounded>
                <TopicTextContainer>
                    <SecondaryText>Erfolgreich gesendet</SecondaryText>
                    <Heading>Danke für deine Nachricht!</Heading>
                </TopicTextContainer>
            </TopicContainer>
            <TextMessageContainer>
                <SmallerHeading>Deine Nachricht wurde bestätigt</SmallerHeading>
                <SecondaryText >Du erhälst zur Bestätigung in Kürze eine Mail.</SecondaryText>
            </TextMessageContainer>
            <SubmitButton text="Zurück zur Hauptseite" onClick={() => navigate("/")} />
        </Container>
    );
}

export default MessageConfirmed;